import Vue from 'vue';
import Vuex from 'vuex';

import { ActiveFlights } from './modules/activeFlights';
import { AirportSettings } from './modules/airportSettings';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    activeFlights: ActiveFlights,
    airportSettings: AirportSettings,
  }
});
